module.exports = __webpack_public_path__ + "static/img/game14.ee98730.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game14.jpg
// module id = 7tui
// module chunks = 1